import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/MakeReviewingApplicantInfluencers.graphql';
import { Mutation, MutationmakeReviewingApplicantInfluencersArgs } from '../../__generated__/globalTypes';

export const useMakeReviewingApplicantInfluencersMutation = (
  options?: MutationHookOptions<Mutation, MutationmakeReviewingApplicantInfluencersArgs>
) => {
  const [callMakeReviewingApplicantInfluencers, result] = useMutation<
    Mutation,
    MutationmakeReviewingApplicantInfluencersArgs
  >(MUTATION, options);

  return { callMakeReviewingApplicantInfluencers, ...result };
};

export type MakeReviewingApplicantInfluencersMutationFunction = Mutation['makeReviewingApplicantInfluencers'];
